module.exports = __webpack_public_path__ + "img/zs5.3062910e.png";